import { render, staticRenderFns } from "./supplierExit.vue?vue&type=template&id=58a928e5&scoped=true&"
import script from "./supplierExit.vue?vue&type=script&lang=js&"
export * from "./supplierExit.vue?vue&type=script&lang=js&"
import style0 from "./supplierExit.vue?vue&type=style&index=0&id=58a928e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a928e5",
  null
  
)

export default component.exports